let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ay3aP")).then(() => parcelRequire('bfUPs'));